import { useTranslation } from 'react-i18next';
import { NotificationMenu } from './NotificationMenu.js';

/**
 * @aiPurpose Topbar "events" notification surface (#2107) — every non-chat
 *   notification type. Chat lives in {@link NotificationMessages}. Preserves
 *   the historical `topbar-bell` / `topbar-bell-badge` testids and the
 *   `bell.button` aria-label so existing tests and clipped visual baselines
 *   keep matching.
 */
export function NotificationBell() {
  const { t } = useTranslation('shell');
  return (
    <NotificationMenu
      channel="events"
      icon="bell"
      ariaLabel={t('bell.button')}
      testIdPrefix="topbar-bell"
    />
  );
}
